<div id="wrapper">
    <app-loading-screen></app-loading-screen>
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event"
            (updateSelectBan)="this.selectBan=$event" (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <div class="allcont logsize m-top-i">
        <div class="basicrow ">
            <div class="container">
                <div class="">
                    <div class="fulltitle  f-btitle autodef">
                        <span class="icon-dash-27"></span> Preguntas Frecuentes Netflix
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow roboto-r f-reg f-black m-top m-bott">
            <div class="container">
                <div class="basicrow roboto-l f-big">
                    Preguntas Frecuentes sobre Facturación
                </div>
                <app-collapse  [(content)]="this.content"></app-collapse>
            </div>
        </div>

        <div class="basicrow m-top-i graybg">
            <div class="container">
                <div class="basicrow m-top m-bott">
                    <div class="basicrow f-big roboto-l f-black">
                        &#191;Necesitas Ayuda&#63;
                    </div>

                    <div class="basicrow m-top-i">
                        <div class="row refdef">
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                <div class="basicrow text-center">
                                    <img width="100%" class="ref-icons" src="../../../assets/images/netflixicon1.png">
                                </div>

                                <div class="basicrow f-black roboto-r f-reg text-center m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        T&eacute;rminos y Condiciones
                                    </div>

                                    <div class="basicrow m-top">
                                        Consulta en esta sección los Términos & Condiciones para el servicio de Netflix en la factura de Claro.
                                        <br/><br/>

                                        <a href="#" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 hrefmtop">
                                <div class="basicrow text-center">
                                    <img width="100%" class="ref-icons" src="../../../assets/images/ico_preguntasFrecuentes.png">
                                </div>

                                <div class="basicrow f-black roboto-r f-reg text-center m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        Preguntas Frecuentes
                                    </div>

                                    <div class="basicrow m-top">
                                        Te invitamos a que visites esta sección para que aclares algunas de las dudas más comunes.
                                        <br/><br/>

                                        <a href="/netflix_questions" ui-sref="netflix_questions" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>


                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 hrefmtop">
                                <div class="basicrow text-center">
                                    <img width="100%" class="ref-icons" src="../../../assets/images/netflixicon3.png">
                                </div>

                                <div class="basicrow f-black roboto-r f-reg text-center m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        Soporte T&eacute;cnico
                                    </div>

                                    <div class="basicrow m-top">
                                        ¿Cómo obtener apoyo técnico por parte de Netflix y/o Claro Puerto Rico si pagas tu servicio de Netflix a través de la factura de Claro?
                                        <br/><br/>
                                        <a href="/netflix_support" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="basicrow roboto-r f-med f-black">
            <div class="container m-top-i m-bott">
                <div class="row m-top-i m-bott">
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 text-center">
                        <img width="100%" class="n-supp-icon" src="../../../assets/images/netflixicon4.png">
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 text-left">
                        <div class="basicrow">
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="basicrow f-big roboto-l">
                                        Cont&aacute;ctanos
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        Horario de Servicio al Cliente
                                    </div>

                                    <div class="basicrow f-med line-def-i m-top-ii">
                                        Lunes a Viernes: 8:00 a.m - 7:00 p.m<br/> S&aacute;bados y Domingos: 8:00 a.m - 5:00 p.m<br/> D&iacute;as Feriados: 8:00 a.m - 5:00 p.m
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-top">
                                    <div class="basicrow h-mtop f-bmed roboto-b">
                                        Tel&eacute;fonos de Contacto
                                    </div>

                                    <div class="basicrow f-med line-def-i m-top-ii">
                                        Servicio al Cliente: 787-775-0000<br/> &oacute; Marcando &#42;611 desde tu tel&eacute;fono celular.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="basicrow m-top-i graybg">
            <div class="container">
                <div class="basicrow m-top-i m-bott">
                    <div class="basicrow text-center f-black f-btitle">
                        &#191;Olvidaste tu Correo Electr&oacute;nico&#63;
                    </div>

                    <div class="basicrow m-top-ii">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-lg-offset-4 col-md-offset-3">
                                <a href="#" class="btns blue vcenter" ng-click="vm.recuperarCorreo();">
                                    <span class="tabcell">
										Recuperar Ahora&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
									</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>